// auth.js
import axios from 'axios'
import { API_URL } from '@/config/api.config'


// 配置常量
const TOKEN_KEY = 'token';

// 创建一个新的 axios 实例
const authAxios = axios.create({
  baseURL: API_URL,
  timeout: 10000, // 添加请求超时设置
  headers: {
    'Content-Type': 'application/json'
  }
});

// 添加请求拦截器
authAxios.interceptors.request.use(
  config => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
authAxios.interceptors.response.use(
  response => response,
  error => {
    // 统一处理401错误
    if (error.response && error.response.status === 401) {
      console.warn('认证失败，请重新登录');
      // 清除本地token
      localStorage.removeItem(TOKEN_KEY);
    }
    return Promise.reject(error);
  }
);


const authAPI = {
  login: async (username, password) => {
    try {
      const response = await authAxios.post(`/auth/login`, { username, password });
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        authAxios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      }
      return response.data;
    } catch (error) {
      console.error('登录失败:', error);
      throw error;
    }
  },

  getCurrentUser: async () => {
    try {
      const response = await authAxios.get(`/auth/current-user`);
      return response.data;
    } catch (error) {
      console.error('获取用户信息失败:', error);
      throw error;
    }
  },

  logout: async () => {
    try {
      const response = await authAxios.post(`/auth/logout`);
      localStorage.removeItem('token');
      delete authAxios.defaults.headers.common['Authorization'];
      return response.data;
    } catch (error) {
      console.error('退出登录失败:', error);
      throw error;
    }
  },

  setAuthToken: (token) => {
    if (token) {
      localStorage.setItem('token', token);
      authAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      localStorage.removeItem('token');
      delete authAxios.defaults.headers.common['Authorization'];
    }
  }
};

export default authAPI;